import type { FC } from 'react'

import { Group, Stack, Text } from '@mantine/core'
import { CircleHelp } from 'lucide-react'

type AccountHelpfulInfoProps = {
  accountAlias: string
  title: string
  description: string
}

const AccountHelpfulInfo: FC<AccountHelpfulInfoProps> = (props) => {
  const { accountAlias, title, description } = props
  const accountAliasPlaceholder = `<${accountAlias}>`

  return (
    <Stack gap='md'>
      <Stack gap='xs'>
        <Group gap='xs'>
          <CircleHelp size={16} strokeWidth={1} opacity={1} />
          <Text fz='xs' opacity={1} fw={600}>
            {title}
          </Text>
        </Group>
        <Text c='var(--mantine-color-text-secondary)' fz='xs'>
          {description}
        </Text>
      </Stack>
      <Group
        bd='1px solid var(--mantine-color-border)'
        bg='var(--mantine-color-background)'
        gap='xxs'
        px={12}
        py={6}
        w='100%'
        style={{
          borderRadius: 8,
        }}
      >
        <Text c='var(--mantine-color-text-secondary)' fz='xs'>
          https://
        </Text>
        <Text c='var(--mantine-color-text)' fw='500' fz='xs'>
          {accountAliasPlaceholder}
        </Text>
        <Text c='var(--mantine-color-text-secondary)' fz='sm'>
          .shalion.com
        </Text>
      </Group>
    </Stack>
  )
}

export default AccountHelpfulInfo
